import React from 'react';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import './KanziSlideshow.css';

const fadeImages = [
    "KanziSlideshow/BabyKanzi.jpg",
    "KanziSlideshow/GroupPhoto.jpg",
    "KanziSlideshow/KanziAndKeyboard2.jpg",
    "KanziSlideshow/KanziAndSue.jpg",
    "KanziSlideshow/KanziFloorLexigrams.jpg",
    "KanziSlideshow/KanziFrontsKeyboard.jpg",
    "KanziSlideshow/KanziPointsToLexigram.jpg",
    "KanziSlideshow/KanziReachesForSue.jpg",
    "KanziSlideshow/KanziUnderUmbrella.jpg",
    "KanziSlideshow/SleepyBoy.jpg",
    "KanziSlideshow/WetKanzi.jpg",
  ];

const fadeProperties = {
    duration: 2500,             // How long each slide is shown (in ms)
    transitionDuration: 1000,   // Duration of the fade animation (in ms)
    infinite: true,
    arrows: true,
    pauseOnHover: false
  };

const KanziSlideshow = () => {
    return (
        <div className="KanziPhoto-slide-container">
          <Fade {...fadeProperties}>
            <div className="each-fade">
              <img src={fadeImages[0]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[1]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[2]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[3]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[4]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[5]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[6]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[7]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[8]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[9]} />
            </div>
            <div className="each-fade">
              <img src={fadeImages[10]} />
            </div>
          </Fade>
        </div>
      );
}

export default KanziSlideshow;
